import perfiles from "@conductor/context/perfiles";

export default Object.freeze({
    [perfiles.CHOFER]:
        ['/', '/historico-chofer', '/notificaciones', '/seguridad', '/informacion-personal', '/mapa-chofer', '/assigned-items'],
});